import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TextStyle = styled.p`
  line-height: 30px;
`;

const Subtitle = ({ children, size, centered, dark, className }) => (
  <TextStyle
    className={`subtitle ${size} ${
      dark ? 'has-text-grey-dark' : 'has-text-white'
    }
      ${className} ${centered && 'has-text-centered'} `}
  >
    {children}
  </TextStyle>
);

Subtitle.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([
    'is-1',
    'is-2',
    'is-3',
    'is-4',
    'is-5',
    'is-6',
    'is-7',
  ]),
};

Subtitle.defaultProps = {
  className: '',
  size: 'is-6',
};

export default Subtitle;
